import { useMemo } from 'react';
import { Database } from 'lucide-react';
import { MultipleChoiceFilter } from '@duke-hq/ui/components/MultipleChoice/MultipleChoiceFilter';
import useFiltersContext from '@duke-hq/filters/context/useFiltersContext';
import { iconSize } from '@duke-hq/ui/constants/scalable';

const BUCKET_TYPE_OPTIONS = [
  { id: 'PRIVATE', value: 'PRIVATE', label: 'Private' },
  { id: 'PUBLIC', value: 'PUBLIC', label: 'Public' },
  { id: 'SENSITIVE', value: 'SENSITIVE', label: 'Sensitive' },
];

export function BucketTypeFilter() {
  const { updateFilters, filters } = useFiltersContext();

  const selected = useMemo(() => {
    const bucketType = filters['bucketType'] ?? [];
    const validIds = new Set(BUCKET_TYPE_OPTIONS.map(({ id }) => id));
    return bucketType.filter((id: string) => validIds.has(id));
  }, [filters]);

  return (
    <MultipleChoiceFilter
      items={BUCKET_TYPE_OPTIONS}
      label="Bucket"
      name="bucketType"
      onFilterChange={({ bucketType }) => updateFilters({ bucketType })}
      onlyUpdateOnChange
      value={selected.join(',')}
      variant="ghost"
      leftIcon={<Database size={iconSize.md} />}
      rightIcon={undefined}
    />
  );
}
